export default "__VITE_ASSET__BoGkLtTE__"